module.exports = __webpack_public_path__ + "img/store-kv.fde4933c.png";